module.exports = __webpack_public_path__ + "static/media/tv-group.47484de4.svg";